export default "__VITE_ASSET__L_$$wzR8__"